import { z } from 'zod';

export const accountLinkProposalSchema = z.object({
  maskedEmail: z.string(),
  email: z.string(),
  existingProviders: z.array(z.string()),
  requiresEmailVerification: z.boolean(),
  pendingToken: z.string(),
  pendingSpaceJoin: z.boolean().optional().default(false),
});

export const accountLinkConfirmSchema = z.object({
  pendingToken: z.string(),
  verificationCode: z.string().optional(),
  password: z.string().optional(),
});

export type AccountLinkProposalType = z.infer<typeof accountLinkProposalSchema>;
export type AccountLinkConfirmType = z.infer<typeof accountLinkConfirmSchema>;
